'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SvgDeliveryTruck = function (props) {
    var className = props.className;
    var svgProps = tslib_es6.__assign(tslib_es6.__assign({}, props), { className: '' });
    return (React__default['default'].createElement("div", { className: className },
        React__default['default'].createElement("svg", tslib_es6.__assign({ width: "19", height: "14", viewBox: "0 0 19 14", fill: "currentColor" }, svgProps),
            React__default['default'].createElement("defs", null,
                React__default['default'].createElement("path", { fill: "currentColor", id: "DeliveryTruck_svg__a", d: "M13.933 0v4.222h2.069L19 7.81v4.013h-1.309c-.196.964-1.048 1.69-2.069 1.69s-1.873-.726-2.069-1.69l-5.996.002a2.11 2.11 0 01-4.137 0l-2.153-.002V3.387h3.826L5.06 0h8.874zm1.69 9.993a1.407 1.407 0 100 2.815 1.407 1.407 0 00-.001-2.815zm-10.134 0a1.408 1.408 0 100 2.816 1.408 1.408 0 000-2.816zm7.63-9.175H5.915v3.387H2.08v6.799h1.334a2.112 2.112 0 014.148-.001h5.525v-6.78l.031-.001V.818zm2.572 4.25l-1.758-.001v5.067a2.111 2.111 0 013.758.845h.554V8.024L15.69 5.067zM4.222 1.687v.845H.844V1.69h3.378zm0-1.688v.844H0V0h4.222z" })),
            React__default['default'].createElement("g", { fill: "none", fillRule: "evenodd" },
                React__default['default'].createElement("mask", { id: "DeliveryTruck_svg__b", fill: "#fff" },
                    React__default['default'].createElement("use", { xlinkHref: "#DeliveryTruck_svg__a" })),
                React__default['default'].createElement("use", { fill: "#323232", xlinkHref: "#DeliveryTruck_svg__a" })))));
};

exports.default = SvgDeliveryTruck;
//# sourceMappingURL=index.js.map
